import { i18n } from "../main";
import cuid from "cuid";
export function reviewsHeaders() {
  return [
    {
      id: cuid(),
      text: i18n.t("message.reviews.categories.gridColumns.categories"),
      align: "start",
      sortable: false,
      value: "name"
    },
    {
      id: cuid(),
      text: i18n.t(
        "message.reviews.categories.gridColumns.reviewsCountInPeriod"
      ),
      value: "count",
      type: "standard",
      sort_value: "count",
      event_action_name: "count",
      sortable: true,
      align: "center",
      width: "100px"
    },
    {
      id: cuid(),
      text: i18n.t(
        "message.reviews.categories.gridColumns.countInComparisonPeriod"
      ),
      value: "count_selected",
      type: "standard",
      sort_value: "count",
      event_action_name: "count_selected",
      sortable: true,
      align: "center",
      width: "100px"
    },
    {
      id: cuid(),
      text: i18n.t("message.reviews.categories.gridColumns.rates"),
      rate: "5",
      value: "rating_5",
      sort_value: "rating_5",
      event_action_name: "rating_5",
      sortable: true,
      align: "center"
    },
    {
      id: cuid(),
      text: i18n.t("message.reviews.categories.gridColumns.rates"),
      rate: "4",
      value: "rating_4",
      sort_value: "rating_4",
      event_action_name: "rating_4",
      sortable: true,
      align: "center"
    },
    {
      id: cuid(),
      text: i18n.t("message.reviews.categories.gridColumns.rates"),
      rate: "3",
      value: "rating_3",
      sort_value: "rating_3",
      event_action_name: "rating_3",
      sortable: true,
      align: "center"
    },
    {
      id: cuid(),
      text: i18n.t("message.reviews.categories.gridColumns.rates"),
      rate: "2",
      value: "rating_2",
      sort_value: "rating_2",
      event_action_name: "rating_2",
      sortable: true,
      align: "center"
    },
    {
      id: cuid(),
      text: i18n.t("message.reviews.categories.gridColumns.rates"),
      rate: "1",
      value: "rating_1",
      sort_value: "rating_1",
      event_action_name: "rating_1",
      sortable: true,
      align: "center"
    },
    {
      id: cuid(),
      text: i18n.t("message.reviews.categories.gridColumns.actions"),
      value: "actions",
      sortable: false,
      align: "center"
    }
  ];
}

export function avgRatingHeaders() {
  return [
    {
      id: cuid(),
      text: i18n.t("message.reviews.categories.gridColumns.categories"),
      align: "start",
      sortable: false,
      value: "name"
    },
    {
      id: cuid(),
      text: i18n.t(
        "message.reviews.categories.gridColumns.averageRateInPeriod"
      ),
      value: "avg_review_period",
      type: "standard",
      sort_value: "avg_review_period",
      event_action_name: "avg_review_period",
      sortable: true,
      align: "center"
    },
    {
      id: cuid(),
      text: i18n.t(
        "message.reviews.categories.gridColumns.averageRateInComparisonPeriod"
      ),
      value: "avg_review_period_selected",
      sort_value: "avg_review_period",
      event_action_name: "avg_review_compared_period",
      sortable: true,
      align: "center"
    },
    {
      id: cuid(),
      text: i18n.t(
        "message.reviews.categories.gridColumns.averageRateFromBeginning"
      ),
      value: "avg_review_beginning",
      sort_value: "avg_review_beginning",
      event_action_name: "avg_review_beginning",
      sortable: true,
      align: "center"
    },

    {
      id: cuid(),
      text: i18n.t("message.reviews.categories.gridColumns.actions"),
      value: "actions",
      sortable: false,
      align: "center"
    }
  ];
}

export function avgRatingDetailsHeaders() {
  return [
    {
      id: cuid(),
      text: i18n.t("message.common.businessAddresses"),
      align: "start",
      sortable: false,
      value: "name"
    },
    {
      id: cuid(),
      text: i18n.t(
        "message.reviews.categories.gridColumns.averageRateInPeriod"
      ),
      value: "avg_review_period",
      sort_value: "average",
      event_action_name: "avg_review_period",
      sortable: true,
      align: "center"
    },
    {
      id: cuid(),
      text: i18n.t(
        "message.reviews.categories.gridColumns.averageRateInComparisonPeriod"
      ),
      value: "avg_review_period_selected",
      sort_value: "avg_review_period",
      event_action_name: "avg_review_compared_period",
      sortable: true,
      align: "center"
    },
    {
      id: cuid(),
      text: i18n.t(
        "message.reviews.categories.gridColumns.averageRateFromBeginning"
      ),
      value: "avg_review_beginning",
      sort_value: "average_total",
      event_action_name: "avg_review_beginning",
      sortable: true,
      align: "center"
    },
    {
      id: cuid(),
      text: i18n.t("message.reviews.categories.gridColumns.actions"),
      value: "actions",
      sortable: false,
      align: "center"
    }
  ];
}

export function sentimentHeaders() {
  return [
    {
      id: cuid(),
      text: i18n.t("message.reviews.categories.gridColumns.categories"),
      align: "start",
      sortable: false,
      value: "name"
    },
    {
      id: cuid(),
      text: i18n.t("message.reviews.categories.gridColumns.reviewsCount"),
      value: "reviews_count",
      type: "standard",
      sort_value: "reviews_count",
      event_action_name: "reviews_count",
      sortable: true,
      align: "center"
    },
    {
      id: cuid(),
      text: i18n.t("message.reviews.categories.gridColumns.sentiment.positive"),
      value: "positive",
      type: "colorTriad",
      event_action_name: "positive_reviews_count",
      sort_value: "positive_reviews_percentage",
      sortable: true,
      align: "center"
    },
    {
      id: cuid(),
      text: i18n.t("message.reviews.categories.gridColumns.sentiment.neutral"),
      type: "colorTriad",
      value: "neutral",
      event_action_name: "neutral_reviews_count",
      sort_value: "neutral_reviews_percentage",
      sortable: true,
      align: "center"
    },
    {
      id: cuid(),
      text: i18n.t("message.reviews.categories.gridColumns.sentiment.negative"),
      type: "colorTriad",
      value: "negative",
      event_action_name: "negative_reviews_count",
      sort_value: "negative_reviews_percentage",
      sortable: true,
      align: "center"
    },
    {
      id: cuid(),
      text: i18n.t(
        "message.reviews.categories.gridColumns.sentiment.unassigned"
      ),
      type: "colorTriad",
      value: "unassigned",
      event_action_name: "unassigned_reviews_count",
      sort_value: "unassigned_reviews_percentage",
      sortable: true,
      align: "center"
    },
    {
      id: cuid(),
      text: i18n.t("message.reviews.categories.gridColumns.actions"),
      value: "actions",
      sortable: false,
      align: "center"
    }
  ];
}

export function sentimentAggregatedHeaders() {
  return [
    {
      id: cuid(),
      text: i18n.t("message.reviews.categories.gridColumns.categories"),
      align: "start",
      sortable: false,
      value: "name"
    },
    {
      id: cuid(),
      text: i18n.t(
        "message.reviews.categories.gridColumns.sentiment.sentimentInSelectedPeriod"
      ),
      value: "period_sentiment",
      type: "colorScale",
      sort_value: "period_sentiment",
      event_action_name: "sentiment_period",
      sortable: true,
      align: "center"
    },
    {
      id: cuid(),
      text: i18n.t(
        "message.reviews.categories.gridColumns.sentiment.sentimentInComparisonPeriod"
      ),
      value: "selected_period_sentiment",
      type: "colorScale",
      sort_value: "period_sentiment",
      event_action_name: "sentiment_compared_period",
      sortable: true,
      align: "center"
    },
    {
      id: cuid(),
      text: i18n.t(
        "message.reviews.categories.gridColumns.sentiment.sentimentFromBeginning"
      ),
      value: "sentiment",
      type: "colorScale",
      sort_value: "sentiment",
      event_action_name: "sentiment_beginning",
      sortable: true,
      align: "center"
    },
    {
      id: cuid(),
      text: i18n.t("message.reviews.categories.gridColumns.actions"),
      value: "actions",
      sortable: false,
      align: "center"
    }
  ];
}
